import Request from "@services/request";
import { IGetAllFormData } from "./types";

const GetAll = async ({ page }: IGetAllFormData) =>
    await new Request().get<
        IReturnValue<IPaginationValue<Array<IForms["get"]>>>
    >("FORMS", {
        params: { page },
    });

// Main Object
const FormsApis = {
    GetAll,
};

export default FormsApis;
